import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import { FiExternalLink, FiInfo, FiPlus, FiTrash2 } from "react-icons/fi";
import { MdClose } from "react-icons/md";

const fixedExpensesList = [
  {
    label: "Expenses Per Day",
    key: "expensesPerDay",
    tooltip: "Daily expenses (CVE, Insurance, etc.)",
    itemsKey: "dailyExpenses",
  },
  {
    label: "On/Off Hire Survey",
    key: "hireSurvey",
    tooltip: "Hire survey expenses (on/off hire)",
    itemsKey: "hireSurveyItems",
  },
  {
    label: "Canal Expenses",
    key: "canalExpenses",
    tooltip: "Canal transit expenses",
    itemsKey: "canalExpensesItems",
  },
  {
    label: "Additional Premium",
    key: "additionalPremium",
    tooltip: "Additional premium costs",
    itemsKey: "additionalPremiumItems",
  },
  {
    label: "ILOHC",
    key: "ilohc",
    tooltip: "In Lieu of Hold Cleaning expenses",
    itemsKey: "ilohcItems",
  },
  {
    label: "Manoevring Exp",
    key: "manoevringExp",
    tooltip: "Manoeuvring expenses",
    itemsKey: "manoevringExpItems",
  },
];

const OtherExpensesModal = ({
  open = false,
  onClose = () => { },
  isReadOnly = false,
  titleSuffix = "",
  expensesData = {},
  onOpenBreakdown = () => { },
  onAddMisc = () => { },
  onRemoveMisc = () => { },
  onRenameMisc = () => { },
  onUpdateMiscAmount = () => { },
  totalAmount = 0,
}) => {
  const formatCurrency = (val) => {
    return Number(val || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const miscItems = expensesData?.miscExp || [];

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Zoom}
      onClose={onClose}
      aria-labelledby="other-expenses-modal-title"
      classes={{
        paper: "rounded-none overflow-hidden shadow-2xl border border-[#cbd5e1]",
      }}
    >
      {/* Header Bar */}
      <div className="flex items-center justify-between w-full px-3 py-2 bg-[#f8fafc] border-b border-[#cbd5e1] text-[#313C4C]">
        <div id="other-expenses-modal-title" className="flex items-center gap-2">
          <Tooltip title="Sum of all operational and miscellaneous expenses" placement="top" arrow>
            <div className="flex items-center gap-1.5 cursor-pointer">
              <h2 className="text-[11px] font-medium capitalize tracking-wide text-slate-800 m-0">
                Other Expenses {titleSuffix ? `(${titleSuffix})` : ""}
              </h2>
              <FiInfo className="w-3.5 h-3.5 text-slate-400 hover:text-slate-600 transition-colors" />
            </div>
          </Tooltip>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="flex items-center gap-1 text-slate-600 hover:text-slate-900 px-2 py-1 rounded-none border border-[#cbd5e1] hover:bg-slate-100 transition-all cursor-pointer text-[11px] font-medium capitalize"
        >
          <MdClose size={14} />
          <span className="hidden md:block text-[11px] font-medium capitalize">
            Close
          </span>
        </button>
      </div>

      {/* Dialog Body */}
      <DialogContent className="p-2 sm:p-3 bg-white">
        <div className="bg-white rounded-none border border-[#cbd5e1] overflow-hidden">
          {/* Main Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse text-[11px] font-medium capitalize">
              <thead className="bg-[#e2e8f0] text-[#1e293b]">
                <tr className="h-[19px]">
                  <th scope="col" className="px-2 py-0.5 h-[19px] align-middle text-left font-medium text-[11px] text-[#1e293b] capitalize border-r border-b border-[#cbd5e1] w-[50%]">
                    Expense Category / Description
                  </th>
                  <th scope="col" className="px-2 py-0.5 h-[19px] align-middle text-left font-medium text-[11px] text-[#1e293b] capitalize border-r border-b border-[#cbd5e1] w-[25%]">
                    Amount
                  </th>
                  <th scope="col" className="px-2 py-0.5 h-[19px] align-middle text-center font-medium text-[11px] text-[#1e293b] capitalize border-r border-b border-[#cbd5e1] w-[25%] whitespace-nowrap">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {/* Fixed Expenses Rows */}
                {fixedExpensesList.map(({ label, key, tooltip, itemsKey }) => {
                  const val = Number(expensesData[key] || 0);
                  return (
                    <tr key={key} className="h-[19px] hover:bg-slate-50/50 transition-colors">
                      <td className="px-2 py-0 h-[19px] align-middle border-r border-b border-[#cbd5e1]">
                        <Tooltip title={<span className="text-[11px] font-medium capitalize">{tooltip}</span>} placement="top" arrow>
                          <div
                            onClick={() => onOpenBreakdown({ label, key, itemsKey })}
                            className="flex items-center gap-1 font-medium text-slate-800 hover:text-[#313C4C] text-[11px] capitalize cursor-pointer select-none transition-colors"
                          >
                            <span>{label}</span>
                          </div>
                        </Tooltip>
                      </td>
                      <td className="px-2 py-0 h-[19px] align-middle font-medium text-slate-800 text-[11px] bg-[#f0f4f9] border-r border-b border-[#cbd5e1]">
                        {formatCurrency(val)}
                      </td>
                      <td className="px-2 py-0 h-[19px] align-middle text-center whitespace-nowrap border-r border-b border-[#cbd5e1]">
                        <button
                          type="button"
                          onClick={() => onOpenBreakdown({ label, key, itemsKey })}
                          className="inline-flex items-center justify-center gap-1 text-[11px] font-medium text-[#1e293b] underline cursor-pointer bg-transparent border-none p-0 outline-none whitespace-nowrap select-none"
                        >
                          <span>View Details</span>
                          <FiExternalLink className="w-2.5 h-2.5 flex-shrink-0" />
                        </button>
                      </td>
                    </tr>
                  );
                })}

                {/* Sub-header for Dynamic Miscellaneous Expenses */}
                <tr className="h-[19px] bg-[#e2e8f0] text-[#1e293b] border-b border-[#cbd5e1]">
                  <td colSpan={3} className="px-2 py-0.5 h-[19px] align-middle font-medium text-[11px] text-[#1e293b] capitalize border-r border-[#cbd5e1]">
                    Miscellaneous Expenses
                  </td>
                </tr>

                {/* Dynamic Misc Expense Rows */}
                {miscItems.length > 0 ? (
                  miscItems.map((expItem, index) => {
                    const rowId = expItem.id ?? index;
                    return (
                      <tr key={rowId} className="h-[19px] hover:bg-slate-50/50 transition-colors">
                        {/* Label Input */}
                        <td className="p-0 h-[19px] align-middle border-r border-b border-[#cbd5e1] bg-[#ffffd6] focus-within:bg-white focus-within:ring-1 focus-within:ring-amber-500 focus-within:ring-inset focus-within:z-10 relative">
                          <input
                            type="text"
                            disabled={isReadOnly}
                            value={expItem.label ?? ""}
                            onChange={(e) => onRenameMisc(expItem, index, e.target.value)}
                            placeholder="Expense description..."
                            className="w-full h-[19px] block px-2 py-0 rounded-none border-none outline-none focus:outline-none focus:ring-0 bg-transparent text-slate-800 placeholder:text-slate-400 disabled:bg-[#f0f4f9] disabled:text-slate-400 disabled:cursor-not-allowed font-medium text-[11px] capitalize cargo-table-input"
                          />
                        </td>

                        {/* Amount Input */}
                        <td className="p-0 h-[19px] align-middle border-r border-b border-[#cbd5e1] bg-[#ffffd6] focus-within:bg-white focus-within:ring-1 focus-within:ring-amber-500 focus-within:ring-inset focus-within:z-10 relative">
                          <input
                            type="number"
                            disabled={isReadOnly}
                            value={expItem.amount === 0 ? "" : expItem.amount ?? ""}
                            onChange={(e) => onUpdateMiscAmount(expItem, index, e.target.value)}
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            className="w-full h-[19px] block px-2 py-0 rounded-none border-none outline-none focus:outline-none focus:ring-0 bg-transparent text-slate-800 font-medium text-[11px] capitalize placeholder:text-slate-400 disabled:bg-[#f0f4f9] disabled:text-slate-400 disabled:cursor-not-allowed cargo-table-input"
                          />
                        </td>

                        {/* Delete Button */}
                        <td className="px-1 py-0 h-[19px] align-middle text-right whitespace-nowrap border-r border-b border-[#cbd5e1] bg-white">
                          {!isReadOnly && (
                            <button
                              type="button"
                              onClick={() => onRemoveMisc(expItem, index)}
                              className="p-0.5 rounded-none transition-colors text-slate-400 hover:text-rose-600 hover:bg-rose-50 cursor-pointer inline-flex items-center justify-center"
                              title="Delete expense item"
                            >
                              <FiTrash2 className="w-3 h-3" />
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={3} className="px-2 py-2 text-center text-slate-400 italic text-[11px] font-medium capitalize border-r border-b border-[#cbd5e1]">
                      No miscellaneous expenses added.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Subtable Footer / Actions & Summary */}
          <div className="flex flex-wrap items-center justify-between gap-2 px-2 py-1.5 bg-[#f0f4f9] border-t border-[#cbd5e1]">
            <div>
              {!isReadOnly && (
                <button
                  type="button"
                  onClick={onAddMisc}
                  className="inline-flex items-center gap-1 px-2 py-1 text-[11px] font-medium capitalize rounded-none bg-[#313C4C] text-white hover:bg-[#1e2632] transition cursor-pointer"
                >
                  <FiPlus className="w-3 h-3" />
                  <span className="text-[11px] font-medium capitalize">Add Miscellaneous Expense</span>
                </button>
              )}
            </div>

            <div className="flex items-center gap-1.5 text-[11px] font-medium capitalize">
              <span className="text-slate-600 font-medium capitalize">
                Total Other Expenses:
              </span>
              <div className="px-2 py-0.5 rounded-none bg-[#f0f4f9] border border-[#cbd5e1] text-[#1e293b] font-medium text-[11px]">
                {formatCurrency(totalAmount)}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>

      {/* Modal Actions Footer */}
      <div className="flex items-center justify-end px-3 py-2 border-t border-[#cbd5e1] bg-white">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-1 text-[11px] font-medium capitalize text-slate-700 hover:bg-slate-100 border border-[#cbd5e1] rounded-none transition cursor-pointer"
        >
          Save
        </button>
      </div>
    </Dialog>
  );
};

export default OtherExpensesModal;
